
export const booking_api = "https://typical-denim-krypton.glitch.me/book"
export const _availableSeats = "https://typical-denim-krypton.glitch.me/seats"